"use client";

import React from "react";
import { useInView } from "react-intersection-observer";

interface FadeInSectionProps {
  children: React.ReactNode;
  delay?: number;
  threshold?: number;
  direction?: "up" | "down" | "left" | "right";
}

const FadeInSection = ({
  children,
  delay = 0,
  threshold = 0.1,
  direction = "up",
}: FadeInSectionProps) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold });

  const directionMap = {
    up: "translateY(-40px)",
    down: "translateY(40px)",
    left: "translateX(-40px)",
    right: "translateX(40px)",
  };

  return (
    <div
      ref={ref}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? "translate(0)" : directionMap[direction],
        transition: `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`,
      }}
    >
      {children}
    </div>
  );
};

export default FadeInSection;
